import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { avecMethodesProductions } from './production.methods';
import { Production } from '../../référentiel-métier-processus/processus-aptitude/models/production.model';

export const ProductionStore = signalStore(
  { providedIn: 'root' },
  withEntities<Production>(),
  avecMethodesProductions(),
);
